import React, { useState, useEffect } from 'react'
import { Pagination, Spin, message } from 'antd';
import { getListDuplicateBaskets } from '../../../services/api/mergerApi';
import BasketsDuplicateTable from './BasketsDuplicateTable';


function BasketsDuplicatePage() {
    const [loading, setLoading] = useState(false);
    const [listData, setListData] = useState([]);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(20);
    const [total, setTotal] = useState(0);

    const fetchListBasketsDuplicate = async () => {
        setLoading(true)
        try {
            const payload = {
                page: page,
                limit: limit
            }
            const { data: res } = await getListDuplicateBaskets(payload)
            const { success, data, message: mess } = res || {}
            if (!success) {
                throw new Error(mess || 'Failed to fetch baskets duplicate')
            }
            const { baskets = [], total } = data || {}
            setListData(baskets)
            setTotal(total || 0)
        } catch (error) {
            message.error(error.message || 'Error fetching baskets duplicate')
            setError(error.message || 'Error fetching baskets duplicate')
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchListBasketsDuplicate()
    }, [page, limit]);

    const _handlePageChange = (current) => {
        setPage(current)
    }

    const _handleShowSizeChange = (current, size) => {
        setLimit(size)
        setPage(1)
    }

    return (
        <div className='BasketsDuplicatePage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mt-3'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <h3>Danh sách giỏ trùng</h3>
                            <div className="listBtn">
                                <a className="ant-btn mr-3 ant-btn-secondary" href="/baskets">Basket</a>
                                <a className="ant-btn mr-3 ant-btn-secondary" href="/statistics-add-basket">Thống kê thêm giỏ</a>
                                <a className="ant-btn ant-btn-secondary mr-3" href="/statistics-delete-basket">Thống kê xóa giỏ</a>
                                <a className="ant-btn ant-btn-secondary mr-3" href="/statistics-uncomplete-basket">Thống kê giỏ chưa hoàn thành</a>
                            </div>
                        </div>
                        {/* <div className='jumbotron p-3 mb-3'>
                            <div className='row align-items-end'>
                            </div>
                        </div> */}

                        <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                            <div>
                                {error && <div className='text-danger'>{error}</div>}
                            </div>
                            <Pagination current={page} total={total} pageSize={limit}
                                showTotal={(sum, range) => sum > 0 &&
                                    <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                    </div>}
                                onChange={_handlePageChange}
                                className='text-right' showSizeChanger
                                pageSizeOptions={['10', '20', '50', '100']}
                                onShowSizeChange={_handleShowSizeChange} />
                        </div>
                        <Spin spinning={loading} tip='Loading...'>
                            <BasketsDuplicateTable
                                listData={listData}
                                loading={loading}
                                resetData={fetchListBasketsDuplicate}
                            />
                        </Spin>

                        <Pagination current={page} total={total} pageSize={limit}
                            onChange={_handlePageChange}
                            showQuickJumper
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onShowSizeChange={_handleShowSizeChange} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BasketsDuplicatePage